import { useCallback, useContext, useMemo } from 'react'
import { SegmentedControl } from 'ui'
import { fitDimensions } from 'utils'
import { UgeArtboardContext } from '../../contexts/artboard'
import { UgeCropContext } from '../../contexts/crop'
import { cropAspectRatio, cropLabel, ugeCropTypes } from '../../types/crop'
import { Label } from '../style'

type Props = {
    className?: string
}

const CropEditorAspectRatio = ({ className }: Props) => {
    const { crop, cropType, setCrop, setCropType } = useContext(UgeCropContext)
    const board = useContext(UgeArtboardContext)

    const filteredCropOptions = useMemo(
        () =>
            ugeCropTypes.filter((option) => {
                if (option !== 'original') {
                    return cropAspectRatio(option) !== board.aspectRatio
                } else {
                    return true
                }
            }),

        [board.aspectRatio]
    )

    const onCropChange = useCallback(
        (index: number) => {
            const { height, width } = board
            const type = filteredCropOptions[index]

            if (type !== cropType) {
                const ratio = cropAspectRatio(type, board.aspectRatio)

                setCropType(type)

                if (ratio) {
                    setCrop(fitDimensions({ width, height: Math.round(width / ratio) }, { height, width }))
                } else {
                    setCrop({ height, width, x: 0, y: 0 })
                }
            }
        },
        [board, crop, filteredCropOptions]
    )

    return (
        <div className={className}>
            <Label>Crop</Label>
            <SegmentedControl
                index={filteredCropOptions.indexOf(cropType)}
                options={filteredCropOptions.map(cropLabel)}
                onChange={onCropChange}
            />
        </div>
    )
}

export default CropEditorAspectRatio
